import React, { useEffect, useRef, useState } from "react";
import Button from "components/button";
import { Heart, ThumbsUp } from "lucide-react";

const ICONS = {
    heart: Heart,
    react: ThumbsUp,
};

const COLORS = {
    heart: "text-pink-600 dark:text-pink-400",
    react: "text-emerald-600 dark:text-emerald-400",
};

const ReactionButton = ({
    type,
    recordData,
    rcw_id,
    authUser,
    doCreate,
    deDelete,
    onChange,
}) => {

    const Icon = ICONS[type] || ThumbsUp;

    const reactions =
    recordData?.user_reacted?.filter(
            r => r.code === `URCTYPE_${type.toUpperCase()}`
        ) || [];

    const initialActive = reactions.length > 0;

    const initialCount =
    recordData?.user_reaction_counts?.[`URCTYPE_${type.toUpperCase()}`] ?? 0;

    const [active, setActive] = useState(initialActive);
    const [count, setCount] = useState(initialCount);

    const lockRef = useRef(false);

    useEffect(() => {
        setActive(initialActive);
        setCount(initialCount);
    }, [recordData]);

    const handleClick = async () => {
        if (!authUser?.id || lockRef.current) return;

        lockRef.current = true;

        const next = !active;

        const prevActive = active;
        const prevCount = count;

        setActive(next);
        setCount(prev => (next ? prev + 1 : Math.max(0, prev - 1)));

        onChange?.(next ? 1 : -1);

        try {
            if (next) {
                await doCreate({
                    urc_user_id: authUser.id,
                    reaction_type: type,
                    urc_recognition_wall_id: rcw_id,
                });
            } else {
                const reactionToDelete = 
                    recordData?.user_reacted?.find(r => r.code === `URCTYPE_${type.toUpperCase()}`);

                if (reactionToDelete) {
                    await deDelete({
                        recordId: reactionToDelete.id,
                        mode: "silent"
                    });
                }
            }
        } catch (err) {
            setActive(prevActive);
            setCount(prevCount);
        } finally {
            lockRef.current = false;
        }
    };

    return (
        <Button
            onClick={handleClick}
            className={`flex items-center gap-1.5 text-xs font-medium
                hover:scale-110 transition-transform !p-0 hover:shadow-none
                ${active ? COLORS[type] : "muted-text"}`}
        >
            <Icon className="w-4 h-4" fill={active ? "currentColor" : "none"} />
            <span>{count}</span>
        </Button>
    );
};

export default ReactionButton;